
<div *ngIf='menuItemsView.length !== 0' dir="ltr'" class="sx-multilevel-sidenav">
    <mat-list>
        <app-multi-level-menu-item *ngFor="let node of menuItemsView"
        [node]="node"
        [level]="0"
        [submenuLevel]="1" 
        [selectedNode]='currentNode'
        [meteringPoints]="this.meteringPoints"
        [isWhiteLabel]="isWhiteLabel"
        (selectedItem)="selectedListItem($event)">
      </app-multi-level-menu-item> 
    </mat-list>
</div>


